import type { SVGProps } from 'react'

/**
 * Con bọ nét mảnh (đầu tròn + hai râu, thân bầu dục, ba chân mỗi bên) — cùng độ dày nét với icon menu (lucide), gọn hơn `Bug` của lucide.
 * Dùng cho nút Gửi Feedback.
 */
export function BugIcon({ strokeWidth = 1.6, ...props }: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
      strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" {...props}
    >
      {/* đầu + râu */}
      <path d="M9.4 8.4V7a2.6 2.6 0 0 1 5.2 0v1.4" />
      <path d="M9.2 4 7.6 2.4M14.8 4l1.6-1.6" />
      {/* thân + sống lưng */}
      <path d="M12 8.4c-2.4 0-4.3 1.9-4.3 4.4v1.1c0 3.1 1.9 5.6 4.3 5.6s4.3-2.5 4.3-5.6v-1.1c0-2.5-1.9-4.4-4.3-4.4Z" />
      <path d="M12 11v8" />
      {/* chân */}
      <path d="M7.7 12.6H4M7.9 16.3l-3 1.8M8.2 9.9 5.4 8.2" />
      <path d="M16.3 12.6H20M16.1 16.3l3 1.8M15.8 9.9l2.8-1.7" />
    </svg>
  )
}
